import React from 'react';
import { useAppSelector } from '../redux/hooks';
import { selectCurrentLanguage, selectDirection } from '../redux/selectors';

import textsMapper from '../staticTexts/texts';

import logo from '../assets/Xsite.svg'
import errorStyles from './ErrorPage.module.css'
import '../styles/common/animations.css'
import { Typography } from '@mui/material';

const ErrorPage: React.FC = () => {

    const currentLanguage = useAppSelector(selectCurrentLanguage)
    const direction = useAppSelector(selectDirection)

    return (
        <div className={errorStyles['error-page']} style={{direction: direction}}>
            <div className="image-wrapper" style={{height: '20vh', width: '20vw'}}>
                <img src={logo} className='pulse-animation' alt='xsite logo'/>
            </div>
            <Typography variant='body1' fontSize='2rem' letterSpacing='-0.32px'>
                {(textsMapper.pages.errorPage.message as Record<string, string>)[(currentLanguage ?? 'en').replace('-', '')]}
            </Typography>
        </div>
    );
};

export default ErrorPage;
